<template>
  <div :qaid="`nav-list-${uid}`" class="px-2 lg:px-0">
    <h4
      v-if="columnHeader"
      class="inline-block mb-1 text-white leading-normal text-lg font-medium lg:text-md"
      v-html="columnHeader"
    />
    <ul>
      <li v-for="link in links" :key="link.uid" class="flex mb-1 items-center lg:items-start">
        <!-- TODO: in Phase 2, include this as the icon component  -->
        <svg
          v-if="link.linkNavMenuIconName"
          class="-ml-25 inline-block flex-none"
          xmlns="http://www.w3.org/2000/svg"
          height="18px"
          viewBox="0 0 24 24"
          width="18px"
          fill="var(--gray-30)"
        >
          <path
            d="M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66.19-.34.05-.08.07-.12C8.48 10.94 10.42 7.54 13 3h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15C12.96 17.55 11 21 11 21z"
          />
        </svg>

        <a :qaid="`nav-link-${link.uid}`" :target="returnTarget(link.target)" :href="link.url" class="nav-list__link ">
          <span v-html="link.linkName" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'NavList',
  props: {
    columnHeader: {
      type: String,
      default: null,
    },
    links: {
      type: Array,
      required: true,
    },
    uid: {
      type: String,
      required: true,
    },
  },
  methods: {
    returnTarget(option) {
      return option === 'NEWWINDOW' ? '_blank' : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-list__link {
  @apply inline-block;
  @apply text-gray-30;
  @apply font-medium;
  @apply leading-normal;
  @apply text-md;

  &:hover {
    @apply text-white;
    @apply underline;
  }

  &:focus {
    @apply text-white;
    @apply underline;
  }

  transition: all 0.25s ease-out;
  text-decoration-color: var(--gray-30);

  @include breakpoint(large) {
    @apply text-sm;
  }
}
</style>
